/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { BannerCarousel } from '@/components/molecules/Carousel';
import { useTheme } from '@/pages/Bookstore/contexts/BookstoreThemeAdapter';

/**
 * Carrossel de banners da bookstore.
 *
 * Os banners vêm do agreement (mesma lista da Home/Produtos, exposta pelo tema do
 * super-app e repassada pelo BookstoreThemeAdapter). Aqui só entram os cadastrados
 * como `type: 'book'` — os de `type: 'discount'` continuam exclusivos da Home.
 *
 * Retorna null quando não há banners: o BannerCarousel quebra se receber undefined.
 */
export function BookstoreBanners() {
  const { banners, isNative } = useTheme();

  const bookBanners = useMemo(
    () => (banners ?? []).filter((banner: any) => banner?.type === 'book'),
    [banners]
  );

  if (bookBanners.length === 0) {
    return null;
  }

  return (
    <Box width="100%" paddingX="5%" boxSizing="border-box">
      <BannerCarousel banners={bookBanners} isNative={isNative} />
    </Box>
  );
}
